var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelchair({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1907 16.5275H12.1884V10.5474H18.1685V6.56156H8.20172V20.5133H18.1388L22.5256 26.6556L25.7698 24.3378L20.1907 16.5275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27021 25.4321C8.2465 25.4321 7.24691 25.1213 6.40372 24.5408C5.56053 23.9603 4.9135 23.1374 4.54824 22.1811C4.18299 21.2248 4.11674 20.1801 4.35826 19.1852C4.59978 18.1904 5.13768 17.2924 5.90078 16.61L3.24186 13.6396C2.26717 14.5119 1.49335 15.5853 0.973805 16.7858C0.454258 17.9862 0.201356 19.285 0.232553 20.5927C0.263749 21.9003 0.578301 23.1856 1.1545 24.3599C1.7307 25.5342 2.55483 26.5695 3.57001 27.3943C4.58519 28.2191 5.76725 28.8139 7.03461 29.1375C8.30197 29.4611 9.62446 29.5058 10.9108 29.2687C12.1972 29.0315 13.4167 28.5181 14.4854 27.7638C15.554 27.0095 16.4463 26.0324 17.1005 24.8997L13.6494 22.9036C13.2042 23.6711 12.5656 24.3085 11.7972 24.7522C11.0288 25.1959 10.1575 25.4303 9.27021 25.4321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1885 0.581467H8.20207V4.56792H12.1885V0.581467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.60aaac26e180f84c0d965a24013ee822.svg";
export { ForwardRef as ReactComponent };